// removed by extract-text-webpack-plugin
module.exports = {"sectionHeaderContent":"SectionHeader__sectionHeaderContent___1SrK9","sectionHeader":"SectionHeader__sectionHeader___2ISQJ","noMargin":"SectionHeader__noMargin___1XKeF","hr":"SectionHeader__hr___2-xJj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SummarySubSections/SummarySubSection/SectionHeader/SectionHeader.less
// module id = 1213
// module chunks = 0